import React, { useReducer } from "react";

export type InvoiceDetailsReducerState = {
  busy: boolean;
};

export enum InvoiceDetailsActionType {
  Busy = 0,
}

type BusyAction = {
  type: InvoiceDetailsActionType.Busy;
  value?: boolean;
};

export type InvoiceDetailsReducerAction = BusyAction;

export class InvoiceDetailsDispatcher {
  constructor(readonly dispatch: React.Dispatch<InvoiceDetailsReducerAction>) {}

  sendBusy(busy?: boolean) {
    this.dispatch({ type: InvoiceDetailsActionType.Busy, value: busy ?? true });
  }
}

const defaultState: InvoiceDetailsReducerState = {
  busy: false,
};

export function useInvoiceDetailsDispatcher(
  reducer: React.Reducer<
    InvoiceDetailsReducerState,
    InvoiceDetailsReducerAction
  >,
  initialState: Partial<InvoiceDetailsReducerState>,
): [InvoiceDetailsReducerState, InvoiceDetailsDispatcher] {
  const [state, dispatch] = useReducer(reducer, {
    ...defaultState,
    ...initialState,
  });
  const dispatcher = new InvoiceDetailsDispatcher(dispatch);
  return [state, dispatcher];
}
